import { createGoogleMap } from "@soft-db/google-maps";
import { __DEV__ } from "../constants";

const key = "AIzaSyDfexEG7LrcQbZ7nXtCUMMXU3sqEveBVFA";

const DEV_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

export const googleMaps = createGoogleMap({
	key: !__DEV__ ? key : DEV_KEY,
});
